import {type} from 'arktype';
import {VerificationMethodType} from './VerificationMethod';

export type TwoFaProvider = ({} & (typeof TwoFaProvider)['~standard']['types'])['output'];
export const TwoFaProvider = type({
    kind: "'otp'",
}).or({
    kind: "'sms'",
    // FIXME: this is imported as type to prevent circular dependencies
    method: type("'sms' | 'telegram' | 'whatsapp'") satisfies {infer: VerificationMethodType},
});
